module.exports = __webpack_public_path__ + "static/media/icon-task.52dea4cc.svg";